import { httpBackOfficeUtil } from "./httpBackOfficeUtil"
import { createCommonResult, createResult, ErrorCodes } from "./resultUtil"

export const subscriptions = {
    getContactSubscriptions,
    getContactServices,
    addSubscriptionDevices,
    enableDevices,
    getSubscriptionDevices,
    getDevice,
    updateDevice,
    updateSubscriptionDevice,
    getSubscriptionAction,
    getServiceDevices
}


async function getContactSubscriptions(contactId) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/contacts/' + contactId + '/subscriptions',
            queryParams: {
                include_terms: true
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getContactSubscriptions: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}



async function getContactServices({
    contact_id,
    subscription_id
} = {}) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/contacts/' + contact_id + '/services',
            queryParams: {
                subscription_id: subscription_id
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getContactServices: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}


async function addSubscriptionDevices({
    device_id,
    subscription_id
}) {
    try {
        let response = await httpBackOfficeUtil.post({
            resourcePath: '/v2/subscriptions/' + subscription_id + '/devices',
            withAccessToken: true,
            body: {
                device_id
            },
        });
        return createCommonResult(response);
    } catch (error) {
        console.log("AAAA addSubscriptionDevices: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}

async function enableDevices({
    devices,
    service_id,
}) {
    try {
        let body = [];
        for (let i = 0; i < devices.length; i++) {
            body.push({
                action: "ENABLE",
                device_id: devices[i].device_id
            })
        }
        let response = await httpBackOfficeUtil.post({
            resourcePath: '/v2/services/' + service_id + '/devices',
            withAccessToken: true,
            body: body
        });
        return createCommonResult(response);
    } catch (error) {
        console.log("AAAA enableDevices: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}

async function getSubscriptionDevices({
    subscription_id,
    search_value
} = {}) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/subscriptions/' + subscription_id + '/allowed_devices',
            queryParams: {
                subscription_id: subscription_id,
                search_value
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getSubscriptionDevices: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getDevice({
    contact_id,
    owner_id,
    serial_number,
    include_subscription = true,
    subscription_ids,
    include_custom_fields = true,
    custom_fields,
    in_warehouse = true
}={}) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/devices',
            queryParams: {
                contact_id,
                serial_number,
                include_subscription,
                subscription_ids,
                include_custom_fields,
                custom_fields,
                in_warehouse,
                owner_id
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getDevice: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateDevice({ custom_fields } = {}, deviceId) {
    try {
        let response = await httpBackOfficeUtil.put({
            resourcePath: `/v2/devices/${deviceId}`,
            body: {
                custom_fields
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateDevice: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateSubscriptionDevice({ action, replaced_by_device_id } = {}, subId, deviceId) {
    try {
        let response = await httpBackOfficeUtil.put({
            resourcePath: `/v2/subscriptions/${subId}/devices/${deviceId}`,
            body: {
                action,
                replaced_by_device_id,
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateSubscriptionDevice: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getSubscriptionAction({
    action_id,
}) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/subscriptions/actions/' + action_id,
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getSubscriptionAction: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getServiceDevices({
    service_id
} = {}) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/services/' + service_id + '/devices',
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getServiceDevices: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}